import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:상품등록 > 색상관리
 * 세부설명:
*/

export class ColorReg extends Component {
    static displayName = ColorReg.name;
    constructor(props) {
        super(props);
        this.state = {
            Title:"",
            ColorDataSet: [], //컬러색상표 리스트
            SelectColor:[]    //선택된 컬러표
        };
        this.handleColor_Click = this.handleColor_Click.bind(this);
        this.handleSelect_Click = this.handleSelect_Click.bind(this);
        this.handelCrdNm_Change = this.handelCrdNm_Change.bind(this);
       
    }    
    //컬러값 속성
    GoodsCrdInfo = null;
    //초기화
    componentDidMount() {
        //색상관리 속성 할당
        let GoodsCrdInfo = this.props.ContentState.GoodsCrdInfo;
        if (GoodsCrdInfo !== undefined && GoodsCrdInfo !== null) {
            this.GoodsCrdInfo = Big3Common.Util.Cloen(GoodsCrdInfo);
        }

        this.ColorCodeDataCall();
       
    }
    async ColorCodeDataCall() {
        try {
            //색상코드 012
            const MstCd = "012";
            let Data = await Big3Common.Get(`api/Common/BaseCode/GetCommonCode/${MstCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let ColorList = JSON.parse(Data.dataTable);
                if (ColorList.length > 0) {
                    this.setState({ ColorDataSet: ColorList }); 
                }
            }
            else {
                console.log("등록된 색상이 없습니다.");
            }
        }
        catch (e) {
            console.log("ColorCodeDataCall: ", e)
        }
        return false;
    } 
    handleColor_Click(event, Crd_Cd, Crd_Nm, Crd_No) {

        if (this.state.SelectColor.length > 7) {
            this.setState({ Title: "색상은 최대 8개까지 선택할 수 있습니다." })
            Big3Common.ModalAlert(bootstrap, 'ColorRegAlert');
            return false;
        }
        if (Crd_Cd === "99") {
            if (event.target.className === "col colors no_color") {
                event.target.className = "col colors no_color color_select";
                this.SetColor(Crd_Cd, Crd_Nm, Crd_No); 
                
            }
            else {
                event.target.className = "col colors no_color"; 
                this.RemoveColor(Crd_Cd);
            }
        }
        else {
            if (event.target.className === "col colors") {
                event.target.className = "col colors color_select";
                this.SetColor(Crd_Cd, Crd_Nm, Crd_No);
            }
            else {
                event.target.className = "col colors";
                this.RemoveColor(Crd_Cd);
            }
        }
    }
    //선택 색상 셋업
    SetColor(Crd_Cd, Crd_Nm, Crd_No) {
        let thisColor = this.state.SelectColor;
        let colorjsonmodel = Big3Common.Util.Cloen(this.GoodsCrdInfo);
        colorjsonmodel.Crd_Cd = Crd_Cd;
        colorjsonmodel.Crd_Nm = Crd_Nm;
        colorjsonmodel.Crd_No = Crd_No;
        thisColor.push(colorjsonmodel);
        this.forceUpdate();
        return false;
    }
    //컬러 지우기
    RemoveColor(Crd_Cd) {

        let thisColor = this.state.SelectColor;
        Big3Common.Util.RemoveModelListRow(thisColor, "Crd_Cd", Crd_Cd);
        //선택된 컬러 파렛트 지우기
        document.querySelectorAll(".color_code_box > .color_select").forEach((colorElement) => {
            if (colorElement.id === Crd_Cd) {
                if (Crd_Cd === "99") {
                    colorElement.className = "col colors no_color";
                }
                else {
                    colorElement.className = "col colors";
                } 
            }
        });
        this.forceUpdate();
        return false;
    }
    handleSelect_Click(event) {
         
        if (this.state.SelectColor.length === 0) {
            this.setState({ Title: "색상을 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'ColorRegAlert');
            return false;
        }
        else if (this.state.SelectColor.length > 8) {
            this.setState({ Title: "색상은 최대 8개까지 선택할 수 있습니다." });
            Big3Common.ModalAlert(bootstrap, 'ColorRegAlert');
            return false;
        }
        let ContentState = this.props.ContentState;
        ContentState.GoodsCrdModel = this.state.SelectColor;
        this.props.RenderComponent('GoodsReg', ContentState);     
        event.preventDefault();
    }
    handelCrdNm_Change(event, Crd_Cd) {
        let thisColor = this.state.SelectColor;
        let idx = thisColor.findIndex((element) => (element.Crd_Cd === Crd_Cd));
        if (idx === -1) {
            return false;
        }
        thisColor[idx]["Crd_Nm"] = event.target.value.trim();
         
    }
    //컬러 리스트 랜더링
    ColorRender() {
        let ListData = this.state.ColorDataSet;
        return (
            <div className="color_code_box row row-cols-3">
                {ListData.map(list => 
                    <div className={list.dtl_cd === '99' ? "col colors no_color" : "col colors"}
                        style={{ backgroundColor: list.contt }}
                        key={list.dtl_cd}
                        id= { list.dtl_cd }
                        onClick={(e) => this.handleColor_Click(e, list.dtl_cd, list.dtl_nm, list.contt) }
                    ></div>
                )}
            </div>
        );
    }
    //선택된 컬러 리스트 랜더링
    SeletColorRender() {
        let ListData = this.state.SelectColor;
        return (
            <div>
                {ListData.map(list =>
                    <div className="Material_input_box" key={list.Crd_Cd}>
                        <div className={list.Crd_Cd === '99' ? "color_s no_color" : "color_s"} style={{ backgroundColor: list.Crd_No }}></div>
                        <div className="Material_input">
                            <input type="text" className="form-control"
                                defaultValue={list.Crd_Nm}
                                onBlur={(e) => { this.handelCrdNm_Change(e, list.Crd_Cd) }}
                            />
                        </div>
                        <div className="item_delete" onClick={(e) => this.RemoveColor(list.Crd_Cd)} ></div>
                    </div>
                )}
            </div>
        )
    }

    render() {
        
        let ColorList = this.ColorRender();
        let SelectColorList = this.SeletColorRender();
        return (
            <form>
                <div className="Material_wrap">
                    <div className="category_slectbox">
                        {ColorList }
                        {SelectColorList}
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleSelect_Click }>완료</button>
                </div>   
                <Alert
                    id="ColorRegAlert"
                    title={this.state.Title}
                />
            </form>
        );
    }
}
